module.exports = __webpack_public_path__ + "static/care-15336aa64925eae9b715057d73a23c70.svg";